import React from 'react'
import { RemoteReceiver } from '@remote-ui/core'
import { RemoteRenderer } from '@remote-ui/react/host'
import { Controller } from '@remote-ui/react/build/ts/host'

interface RemoteRendererProps {
	receiver: RemoteReceiver
	controller: Controller
}
const prepareExternalComponentSSR = ({ receiver, controller }: RemoteRendererProps) => () => {
	return <RemoteRenderer receiver={receiver} controller={controller} />
}

export default prepareExternalComponentSSR
